import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-248.89 -348.44 1777.78 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1107 659 365 -83Q346 -102 320.0 -102.0Q294 -102 275 -83L109 83Q90 102 90.0 128.0Q90 154 109 173L640 704L109 1235Q90 1254 90.0 1280.0Q90 1306 109 1325L275 1491Q294 1510 320.0 1510.0Q346 1510 365 1491L1107 749Q1126 730 1126.0 704.0Q1126 678 1107 659Z"
	})
});
export default SvgChevronRight;
